import React, { useEffect, useState } from 'react';
import MesaDraggable from './MesaDraggable';
import MesaVisual from './MesaVisual';
import MesaFormModal from './MesaFormModal';
import api from '../../api/axios';
import { Button } from 'react-bootstrap';

const PlanoSalon = ({
  editable = false,
  mostrarAccionesMozo = false,
  mostrarAccionesCajero = false,
  onMesaClick = () => {},
  onRefresh = () => {},
  businessIdProp = null,
  userProp = null,
}) => {
  const [mesas, setMesas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingMesa, setEditingMesa] = useState(null);
  const [planoActivo, setPlanoActivo] = useState(null);

  const business = businessIdProp || JSON.parse(localStorage.getItem('business'));
  const usuario = userProp || JSON.parse(localStorage.getItem('usuario')) || JSON.parse(localStorage.getItem('user'));

  const fetchMesas = async () => {
    try {
      const res = await api.get(`/tables?business_id=${business?.id}`);
      setMesas(res.data);
      const planosUnicos = [...new Set(res.data.map(m => m.plano_id))];
      if (planoActivo === null && planosUnicos.length > 0) {
        setPlanoActivo(planosUnicos[0]);
      }
      onRefresh();
    } catch (err) {
      console.error('Error al traer mesas:', err);
    }
  };

  useEffect(() => {
    if (!business?.id) return;
    fetchMesas();
  }, [business?.id]);

  const handleDeleteMesa = async (id) => {
    if (!window.confirm('¿Eliminar esta mesa?')) return;
    try {
      await api.delete(`/tables/${id}`);
      fetchMesas();
    } catch (err) {
      console.error('Error al eliminar mesa:', err);
    }
  };

  const planosUnicos = [...new Set(mesas.map(m => m.plano_id))];
  const mesasFiltradas = mesas.filter(m => m.plano_id === planoActivo);

  if (!usuario || planoActivo === null) return null;

  return (
    <div>
      {/* Tabs de plano */}
      <div className="mb-3">
        <h5>🗺️ Plano del salón</h5>
        <div className="d-flex flex-wrap gap-2">
          {planosUnicos.map((planoId) => (
            <Button
              key={planoId}
              variant={planoActivo === planoId ? 'primary' : 'outline-primary'}
              size="sm"
              onClick={() => setPlanoActivo(planoId)}
            >
              Plano {planoId}
            </Button>
          ))}
        </div>
      </div>

      {/* Zona de mesas */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '600px',
          border: '1px solid #ccc',
          borderRadius: '8px',
          background: '#f8f9fa',
          overflow: 'visible',
          zIndex: 0,
        }}
      >
        {/* Botón agregar mesa */}
        {editable && (
          <Button
            variant="success"
            style={{
              position: 'absolute',
              bottom: 20,
              right: 20,
              zIndex: 999,
            }}
            onClick={() => {
              setEditingMesa(null);
              setShowModal(true);
            }}
          >
            ➕ Agregar Mesa
          </Button>
        )}

        {/* Render de mesas */}
        {mesasFiltradas.map((mesa) =>
          editable ? (
            <MesaDraggable
              key={mesa.id}
              mesa={mesa}
              onClick={() => onMesaClick(mesa)}
              onEdit={(m) => {
                setEditingMesa(m);
                setShowModal(true);
              }}
              onDelete={handleDeleteMesa}
              recargar={fetchMesas}
            />
          ) : (
            <MesaVisual
              key={mesa.id}
              mesa={mesa}
              onClick={() => onMesaClick(mesa)}
              mostrarAccionesMozo={mostrarAccionesMozo}
              mostrarAccionesCajero={mostrarAccionesCajero}
              onRefresh={fetchMesas}
            />
          )
        )}

        {/* Modal */}
        <MesaFormModal
          show={showModal}
          onClose={() => setShowModal(false)}
          onSuccess={fetchMesas}
          mesaInicial={editingMesa}
          planoIdActivo={planoActivo}
        />
      </div>
    </div>
  );
};

export default PlanoSalon;
